export interface ITenantLike {
  id: number;
  name: string;
}

export type GetTenantsFn = (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy: string | undefined,
  search: string | undefined
) => Promise<{ items: ITenantLike[]; isLastPage?: boolean }>;

export const pageTenants = (
  tenants: ITenantLike[],
  pageSize: number,
  pageNo: number,
  search?: string
): { items: ITenantLike[]; isLastPage: boolean } => {
  const query = search?.trim().toLowerCase();
  const filtered = query
    ? tenants.filter((tenant) => tenant.name.toLowerCase().includes(query))
    : tenants;
  const start = (pageNo - 1) * pageSize;
  return {
    items: filtered.slice(start, start + pageSize),
    isLastPage: start + pageSize >= filtered.length,
  };
};
